// 开发环境导入组件
module.exports = (file) => {
  return (resolve) => require([`@/views/${file}.vue`], resolve)
}
